import styled from 'styled-components'
import { Navigate, Route, Routes, useParams } from 'react-router-dom'
import { useGetQuery } from 'hooks'
import {
  Box,
  Card,
  GameList,
  PlacesMap,
  PostChiclet,
  ShowPosts,
  Tabs,
  Tab,
  Title
} from 'components'
import { UserChat } from '../games/chat'
import { AddressList } from './components'

const Stage = styled(Box)`
  overflow: "visible";
  box-sizing: "border-box";
  flex: 3;
  display: flex;
  flex-direction: column;
`

const Page = styled(Card)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
`

export const Place = () => {
  const { id } = useParams()
  const { data } = useGetQuery({ url: `/locations/${id}` })
  // Only active queues are shown to users and guests
  const activities = (data?.location?.addresses?.flatMap((a) => a.Queues) || []).filter(
    (q) => q?.state === 'active'
  )

  if (!data) return null

  return (
    <Page>
      <Title level={2} color="link">
        {data?.location?.name}
      </Title>
      <Stage>
        <Tabs>
          <Tab to={`/places/${id}`} end>
            chat
          </Tab>
          <Tab to={`/places/${id}/wall`} end>
            wall ↗
          </Tab>
          <Tab to={`/places/${id}/post`}>post</Tab>
          {activities.length > 0 && (
            <Tab to={`/places/${id}/activities`} end>
              activities
            </Tab>
          )}
          <Tab to={`/places/${id}/details`} end>
            details
          </Tab>
        </Tabs>
        <Routes>
          <Route path="/" element={<UserChat />} />
          <Route path="/wall" element={<Navigate to={`/games/wall/${data.location?.slug || ''}`} replace />} />
          <Route
            path="/post"
            element={
              <>
                <ShowPosts
                  postable_id={data?.location?.id}
                  postable_type="location"
                />
                <PostChiclet
                  postable_id={data?.location?.id}
                  postable_type="location"
                />
              </>
            }
          />
          <Route path="/games" element={<Navigate to={`/places/${id}/activities`} replace />} />
          <Route path="/activities" element={<GameList queue={activities} />} />
          <Route
            path="/details"
            element={
              <>
                <AddressList addresses={data?.location?.addresses} />
                <PlacesMap
                  className="user_place-show"
                  locations={data?.location?.addresses}
                  zoom={18}
                />
              </>
            }
          />
        </Routes>
      </Stage>
    </Page>
  )
}
